var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMySubscription = function SvgMySubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.078 1.408L11.25.08l1.605 1.832v13.361c0 .306.223.558.493.558s.492-.252.492-.558V5.18h.902v10.093c0 .864-.62 1.567-1.383 1.567H2.461c-1.207 0-2.203-1.115-2.203-2.496V1.912L1.875.08l1.172 1.328L4.219.08 5.39 1.408 6.562.08l1.172 1.328L8.906.08l1.172 1.328zm-8.93 12.936c0 .823.586 1.487 1.313 1.487h9.61a1.726 1.726 0 01-.094-.558V2.337l-.727-.823-1.172 1.328-1.172-1.328-1.172 1.328-1.171-1.328L5.39 2.842 4.219 1.514 3.047 2.842 1.875 1.514l-.727.823v12.007zm4.946-8.66V4.25h.937v1.315h1.172v1.062H6.645c-.434 0-.797.399-.797.903 0 .28.117.532.304.704l1.395 1.262c.422.385.656.943.656 1.54 0 .81-.433 1.528-1.101 1.834l-.07.04v1.434h-.938v-1.328H4.922v-1.063H6.48c.434 0 .797-.398.797-.903a.955.955 0 00-.304-.704L5.578 9.084a2.07 2.07 0 01-.656-1.54c0-.81.433-1.528 1.101-1.833l.07-.027z"
  })));
};

export default SvgMySubscription;